import PropTypes from 'prop-types';
import React from 'react';

import { FiltersIcon } from 'components/Icon';
import PillButton from 'components/PillButton';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import FilterToggleBadge from './FilterToggleBadge';

const CollectionFilterToggle = ({
  onClick,
  appliedFilterAmount,
  experimentEngagementIds,
  ...otherProps
}) => (
  <PillButton
    className="CollectionFilterToggle"
    onClick={() => onClick(experimentEngagementIds)}
    ariaLabel={I18n.localize('collectionPage.filterActions.show')}
    text={I18n.localize('collectionPage.filterActions.buttonLabel')}
    id="collection-filter-toggle"
    {...otherProps}
  >
    <FiltersIcon />
    {appliedFilterAmount > 0 && (
      <div className="CollectionFilterToggle__badge">
        <FilterToggleBadge>{appliedFilterAmount}</FilterToggleBadge>
      </div>
    )}
    <style jsx global>
      {`
        .CollectionFilterToggle {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: ${Theme.get('spacing') * 2}px;
        }
        .Icon--FILTERS {
          width: ${Theme.get('spacing') * 4}px;
        }
      `}
    </style>
  </PillButton>
);

CollectionFilterToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
  appliedFilterAmount: PropTypes.number,
  experimentEngagementIds: PropTypes.shape({
    dyDecisionId: PropTypes.string,
    dyVariationId: PropTypes.number,
  }),
};

CollectionFilterToggle.defaultProps = {
  appliedFilterAmount: 0,
  experimentEngagementIds: {},
};

export default CollectionFilterToggle;
